import { AlignJustify } from "lucide-react";
import { useState, lazy, Suspense, useEffect } from "react";
import BalanceDisplay from "../DemoAccount/BalanceDisplay";
import { useDispatch, useSelector } from "react-redux";
import Sidebar from "./Sidebar";
import SportsNav from "./SportsNav";
import {
  selectSiteFevicon,
  selectSiteName,
  selectSiteHeaderColor,
  selectSiteLoginColor,
  selectSiteSignUpColor,
  isSignupUser,
} from "./../../utils/helper/commonSelectors";
import { generatePresignedUrl } from "../../utils/helper/generatePresignedUrl";
import { Helmet } from "react-helmet";
import { toggleLeftSidebar } from "../../redux/slices/sidebarSlice";
import Loader from "../../utils/Loader";
import { displayAuthModal } from "../../redux/slices/authModalSlice";
import SiteLogo from "../../../CommonComponents/SiteLogo";

// Lazy load modals
const LoginModal = lazy(() => import("../Auth/LoginModal"));
const SignUpModal = lazy(() => import("../Auth/SignUpModal"));

const MainNav = ({ ScrollingFooter, FinancialButtonsmb }) => {
  const { showModal } = useSelector((state) => state.authModal);
  const [isOpen, setisOpen] = useState(false);
  const [favIcon, setFavIcon] = useState([]);
  const dispatch = useDispatch();
  const sitefavIcon = useSelector(selectSiteFevicon());
  const signupUser = useSelector(isSignupUser());
  const siteName = useSelector(selectSiteName());
  const setShowModal = (modalname) => {
    dispatch(displayAuthModal(modalname));
  };
  const HeaderColor = useSelector(selectSiteHeaderColor());
  const LoginBtnColor = useSelector(selectSiteLoginColor());
  const SignUpBtnColor = useSelector(selectSiteSignUpColor());

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const signUp = queryParams.get("signUp");
    if (signUp === "true") {
      setShowModal("signup");
    }
  }, []);

  useEffect(() => {
    const fetchLogo = async () => {
      try {
        if (sitefavIcon) {
          const presignedFevUrls = await generatePresignedUrl(sitefavIcon);
          setFavIcon(presignedFevUrls);
          if (siteName) {
            document.title = siteName;
          }
        }
      } catch (error) {
        console.error("Error fetching logos or favicons:", error);
      }
    };

    if (sitefavIcon || siteName) {
      fetchLogo();
    }
  }, [sitefavIcon, siteName]);

  const isLoggedIn = useSelector((state) => state.user.isLoggedIn);

  const toggleDrawer = () => {
    setisOpen((prevIsOpen) => !prevIsOpen);
  };

  

  return (
    <>
      <Helmet>
        <link rel="icon" href={`${String(favIcon)}`} />
        <title>{siteName}</title>
      </Helmet>

      <div
        className="px-2"
        style={{
          backgroundImage: `linear-gradient(180deg, ${HeaderColor?.start}, ${HeaderColor?.end})`,
        }}
      >
     

        <div className="flex  justify-between items-center py-2">
          <div className="flex justify-center items-center space-x-3">
            <button
              className="text-black  rounded-full block md:hidden"
              onClick={() => dispatch(toggleLeftSidebar())}
              style={{ marginRight: "-10px", color: "white" }}
            >
              <AlignJustify />
            </button>
            <SiteLogo className="sm:max-h-16 max-h-14" />
          </div>
          <div className="space-x-2 flex items-center">

      
            {isLoggedIn ? (
              <>
                <BalanceDisplay />
              </>
            ) : (
              <div className="flex space-x-2">
                <button
                  className="text-white p-2.5 px-3 text-xs rounded-xl font-bold"
                  onClick={() => setShowModal("login")}
                  style={{
                    background: `linear-gradient(180deg, ${
                      LoginBtnColor?.start || "#045662"
                    }, ${LoginBtnColor?.end || "#045662"})`,
                  }}
                >
                  LOG IN
                </button>
                <button
                  className="text-white p-2.5 px-3 text-xs rounded-xl font-bold"
                  onClick={() => setShowModal("signup")}
                  style={{
                    border: `2px solid ${SignUpBtnColor.start}`,

                    background: `linear-gradient(180deg, ${SignUpBtnColor?.start}, ${SignUpBtnColor?.end})`,
                  }}
                >
                  SIGN UP
                </button>
              </div>
            )}
          </div>
        </div>
      </div>

      {signupUser &&(
        FinancialButtonsmb
      )}
      {ScrollingFooter}

      <Suspense fallback={<Loader />}>
        {showModal === "login" && (
          <LoginModal
            isOpen={showModal === "login"}
            onClose={() => setShowModal("")}
            setShowModal={setShowModal}
          />
        )}
        {showModal === "signup" && (
          <SignUpModal
            isOpen={showModal === "signup"}
            onClose={() => setShowModal("")}
            setShowModal={setShowModal}
          />
        )}
      </Suspense>
      <SportsNav />
      <Sidebar isOpen={isOpen} toggleDrawer={toggleDrawer} />
    </>
  );
};

export default MainNav;
